module.exports = __webpack_public_path__ + "img/placeholderIcon.e90ad62a.png";